import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
    const phoneNumber = "919527511398";

  const message = `Hello ThinkQuotient Team,

I am interested in AI solutions for my business.

Please share details about your AI automation services, features, and how ThinkQuotient can help improve our business operations.

Looking forward to hearing from you.`;

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="Chat with us on WhatsApp"
      style={styles.whatsappButton}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px) scale(1.05)";
        e.currentTarget.style.boxShadow = "0 14px 30px rgba(37, 211, 102, 0.45)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0) scale(1)";
        e.currentTarget.style.boxShadow = "0 10px 25px rgba(0, 0, 0, 0.25)";
      }}
    >
      <FaWhatsapp style={styles.icon} />
    </a>
  );
};

const styles = {
  whatsappButton: {
    position: "fixed",
    bottom: "26px",
    right: "26px",
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#ffffff",
    textDecoration: "none",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)",
    zIndex: 9999,
    transition: "all 0.25s ease",
    cursor: "pointer",
  },
  icon: {
    fontSize: "34px",
  },
  tooltip: {
    position: "absolute",
    right: "78px",
    backgroundColor: "#111827",
    color: "#ffffff",
    padding: "9px 13px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.18)",
  },
};

export default WhatsAppButton;